module.exports = __webpack_public_path__ + "9b079573d4b5df7f7b004e60c8399fc6.png";